"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FOOTNOTE_REFERENCE = void 0;
const FOOTNOTE_REFERENCE = "ft_nemo-fn_eec-global-disclaimer";
exports.FOOTNOTE_REFERENCE = FOOTNOTE_REFERENCE;
